import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "../../services/utility/autoMapperService";
import BaseListComponent from "../../components/BaseListComponent";
import approvalItemService from "../../services/approval/approvalItemService";
import ItemsTable, {
  filterFieldData,
} from "../../components/tableComponents/itemsTable";
import TableFilterPane from "../../components/tableComponents/tableFilterPane";
import usersService from "../../services/auth/usersService";
import { getCurrentUserSession } from "../../services/auth/authService";
import ApprovalDetail from "./approvalDetail";
import ApprovalItemRule from "./approvalItemRule";
import { printPDF } from "../../services/utility/textFormatService";
import { decodeToken } from "react-jwt";

export interface ApprovalRequestsProps {}

export interface ApprovalRequestsState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  showRuleDetailsModal: boolean;
}

class ApprovalRequestsList extends BaseListComponent<ApprovalRequestsState> {}

class ApprovalRequests extends React.Component<
  ApprovalRequestsProps,
  ApprovalRequestsState
> {
  constructor(props: ApprovalRequestsProps) {
    super(props);
    this.state = {
      data: createFilterData(["status", "currentLevel"]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        {
          name: "status",
          fieldType: "select",
          options: ["Completed", "Pending", "Rejected"],
          value: "",
        },
        { name: "currentLevel", fieldType: "number", value: "" },
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      showRuleDetailsModal: false,
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    data = typeof data === "undefined" ? this.state.data : data;
    const decodedToken = decodeToken(getCurrentUserSession().token || "");

    try {
      data = { ...data };
      data.filterType = {
        item1: "like",
        item2: "2",
      };
      data.userId = {
        item1: "=",
        item2: decodedToken?.["UserId"]?.toString() || "break",
      };
      data.institutionId = {
        item1: "=",
        item2: decodedToken?.["InstitutionId"]?.toString() || "break",
      };
      const approvalItems = await approvalItemService.filterApprovalItems(
        data,
        pageSize,
        currentPage
      );
      this.setState({
        tableItems: mapEntityList({
          entityList: approvalItems.data.item2,
          properties: [
            { oldName: "functionName", newName: "functionName" },
            { oldName: "createdDate", newName: "dateCreated" },
            { oldName: "currentLevel", newName: "currentLevel" },
            { oldName: "logType", newName: "logType" },
            { oldName: "applicableAmount", newName: "applicableAmount" },
            {
              isTag: true,
              oldName: "status",
              newName: "status",
              success: "Completed",
              danger: "Rejected",
              default: "Created",
              primary: "Approved ",
              secondary: "BiMonthly",
              warning: "Pending",
              light: "light",
              dark: "Quaterly",
              split: false,
            },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: approvalItems.data.item1,
        fetching: false,
      });
    } catch (ex) {
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        // this.setState({ errors, fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        // this.setState({ errors, fetching: false });
      }
    }
  };

  toggleRuleDetailsModal = () => {
    this.setState({ showRuleDetailsModal: !this.state.showRuleDetailsModal });
  };

  handleOnExport = async (type: string) => {
    try {
      const decodedToken = decodeToken(getCurrentUserSession().token || "");
      switch (type) {
        case "XLSX":
        case "CSV":
          return await approvalItemService.downloadMyApprovalRequestsReport(
            decodedToken?.["InstitutionId"],
            type
          );
        case "PDF":
          const response =
            await approvalItemService.downloadMyApprovalRequestsReport(
              decodedToken?.["InstitutionId"],
              type
            );
          printPDF(response?.data);
          break;
        default:
          break;
      }
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
      }
    }
  };

  fetchItemById = async (item: any) => {
    // await activityTrailService.saveActivityTrail({
    //   actionType: "View Details",
    //   description: `Viewed details of Approval ${item.name}`
    // });
    this.setState({ fetchingDetail: true });
    // console.log("fetching approval with id: ", item.id);
    const approval = await approvalItemService.retrieveApprovalItemById(
      item.id
    );
    // console.log("approval: ", approval.data);
    // console.log("prev - curr: ", this.state.item);
    let curr = this.state.item.approvalActions
      ? this.state.item.approvalActions
      : null;
    var timeFix = this.timeCorrection(curr, approval.data);
    this.setItemUser(timeFix);
  };

  timeCorrection = (prev, curr) => {
    // console.log("prev - curr", prev, curr.approvalActions);
    if (!prev) return curr;
    let existing = prev.map((x) => x.id);
    var diff: any = [];
    curr.approvalActions.map((x) => {
      if (existing.indexOf(x.id) === -1) {
        diff.push(x);
        x.createdDate = new Date();
      }
      return x;
    });
    // console.log("prev - curr diff", diff);
    return curr;
  };

  setItemUser = async (item) => {
    if (item.logType !== "ApplicationType") {
      const response = await usersService.retrieveUserById(item.userID);
      item["user"] = response.data;
    }
    this.setItemRole(item);
  };

  setItemRole = async (item) => {
    if (item.logType !== "ApplicationType") {
      item["role"] = item.user.userRole;
    }
    this.setState({ item: item, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      // data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>My Approval Requests</b>
              </h3>
            </div>
            <ApprovalRequestsList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData([
                  "status",
                  "currentLevel",
                ]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: [
                  {
                    name: "status",
                    fieldType: "select",
                    options: ["Completed", "Pending", "Rejected"],
                    value: "",
                  },
                  { name: "currentLevel", fieldType: "number", value: "" },
                ],
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
              }) => (
                <Fragment>
                  <ApprovalDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    currentUserSession={getCurrentUserSession()}
                    isApprovalRequest={false}
                    refreshList={() => this.handlePageChange(currentPage, pageSize)}
                    reloadItem={this.fetchItemById}
                    toggleRuleDetailsModal={() => this.toggleRuleDetailsModal()}
                    item={item}
                  />
                  <ApprovalItemRule
                    item={this.state.item}
                    showRuleDetailsModal={this.state.showRuleDetailsModal}
                    toggleRuleDetailsModal={this.toggleRuleDetailsModal}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="ApprovalRequest Items"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              amountColumn={["applicableAmount"]}
                              timeColumn={["dateCreated"]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></ApprovalRequestsList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ApprovalRequests;
